/**
 * Successful Payment Trigger Component
 *
 * Trigger: "had a successful payment"
 * Shows: Stripe plan select (optional)
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';

export const SuccessfulPaymentTrigger: FC<TriggerComponentProps> = ({
  automation,
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    const planName = automation.paymentPlanName;
    if (planName) {
      return <span>{t('automations.triggers.successfulPaymentFor', { plan: planName })}</span>;
    }
    return <span>{t('automations.triggers.successfulPayment')}</span>;
  }
};
